import * as React from 'react'

function SvgDocumentFilled(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 30 30" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4 4v22a2 2 0 002 2h18a2 2 0 002-2V11.994a2 2 0 00-.23-.931l-4.208-7.994A2 2 0 0019.792 2H6a2 2 0 00-2 2zm19.633 9a.5.5 0 00.433-.75L19.933 5.11c-.256-.442-.933-.26-.933.25V11a2 2 0 002 2h2.633z"
        fill="currentColor"
      />
    </svg>
  )
}

export default SvgDocumentFilled
